import { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Utensils, Cake, Star, TrendingUp, ExternalLink, Flame, Croissant, Coffee, Cookie, Paintbrush, ShoppingCart } from 'lucide-react'
import { getPublicStats, productKey } from '../../lib/publicData'
import useInView from '../../hooks/useInView'

const KITCHEN_FOOD_MENU = [
  { category: 'Mukokoroshi', items: [
    { name: 'Full Mukokoroshi', price: 85 },
    { name: 'Half Mukokoroshi', price: 65 },
    { name: 'Mukokoroshi Plate', price: 30 },
    { name: 'Mukokoroshi (Single)', price: 18 },
  ]},
  { category: 'Steak', items: [
    { name: 'Full Steak', price: 85 },
    { name: 'Half Steak', price: 65 },
  ]},
  { category: 'Stew Vors', items: [
    { name: 'Full Stew Vors', price: 85 },
    { name: 'Half Stew Vors', price: 65 },
  ]},
  { category: 'Khwandadza', items: [
    { name: 'Khwandadza Khuhu x3', price: 12 },
    { name: 'Khwanda Plate', price: 30 },
    { name: 'Half Khwanda Dza Khuhu', price: 40 },
  ]},
  { category: 'Chicken Liver', items: [
    { name: 'Full Liver', price: 80 },
    { name: 'Half Liver', price: 55 },
    { name: 'Liver Plate', price: 30 },
  ]},
  { category: 'Mala', items: [
    { name: 'Full Mala A Khuhu', price: 75 },
    { name: 'Half Mala A Khuhu', price: 50 },
    { name: 'Mala Plate', price: 30 },
  ]},
  { category: 'Traditional', items: [
    { name: 'Mashonzha Plate', price: 30 },
    { name: 'Makhaha', price: 10 },
    { name: 'Mutuku', price: 10 },
  ]},
]

const KITCHEN_BAKERY_MENU = [
  { category: 'Bread', items: [
    { name: 'Bread', price: 11 },
    { name: 'Half Bread', price: 5.50 },
  ]},
  { category: 'Buns & Rolls', items: [
    { name: 'Buns (6-pack)', price: 30 },
    { name: 'Yellow Buns', price: 38 },
    { name: 'Polony Buns', price: 14 },
    { name: 'Hotdog Buns', price: 17 },
    { name: 'White Rolls (pack)', price: 15 },
    { name: 'White Rolls x4', price: 10 },
    { name: 'Yellow Rolls (pack)', price: 12 },
  ]},
  { category: 'Scones & Fatcook', items: [
    { name: 'Scones', price: 2 },
    { name: 'Fatcook', price: 2 },
  ]},
  { category: 'School Buns (Mixed)', items: [
    { name: '2-pack', price: 4 },
    { name: '3-pack', price: 6 },
    { name: '4-pack', price: 8 },
    { name: '5-pack', price: 10 },
    { name: '6-pack', price: 12 },
    { name: '12-pack', price: 23 },
  ]},
  { category: 'School Buns (Yellow)', items: [
    { name: '2-pack', price: 5 },
    { name: '3-pack', price: 7 },
    { name: '4-pack', price: 9 },
    { name: '5-pack', price: 11 },
    { name: '6-pack', price: 13 },
    { name: '12-pack', price: 25 },
  ]},
  { category: 'Sandwiches', items: [
    { name: 'Sandwich S8', price: 8 },
    { name: 'Sandwich S11', price: 11 },
    { name: 'Sandwich S13', price: 13 },
    { name: 'Sandwich S15', price: 15 },
    { name: 'Sandwich S17', price: 17 },
    { name: 'Sandwich S18', price: 18 },
    { name: 'Sandwich S19', price: 19 },
    { name: 'Sandwich S21', price: 21 },
    { name: 'Sandwich S23', price: 23 },
  ]},
  { category: 'Extras', items: [
    { name: 'Hotdog', price: 10 },
    { name: 'Russian', price: 8 },
    { name: 'Burger', price: 15 },
    { name: 'Muffin', price: 12 },
    { name: 'Ginger', price: 3 },
    { name: 'Boiled Egg', price: 3.50 },
    { name: 'SCB Rama', price: 13 },
    { name: 'SCB Polony & Atchaar', price: 7 },
  ]},
]

const YAWEHS_BREAKFAST_MENU = [
  { category: 'Baked Goods', items: [
    { name: 'Scones', price: 3 },
    { name: 'Fatcook', price: 3 },
    { name: 'Bread (Brown)', price: 13 },
    { name: 'Bread (White)', price: 14 },
    { name: 'White Rolls', price: 16 },
    { name: 'Yellow Rolls', price: 16 },
    { name: 'Hotdog Rolls', price: 10 },
  ]},
  { category: 'School Buns', items: [
    { name: '2 School Buns', price: 5 },
    { name: '4 School Buns', price: 10 },
    { name: '6 School Buns', price: 15 },
    { name: '12 School Buns', price: 28 },
    { name: '20 School Buns', price: 49 },
  ]},
  { category: 'Sandwiches & Toast', items: [
    { name: 'Plain Toast', price: 8 },
    { name: 'Polony & Cheese', price: 15 },
    { name: 'Chicken Mayo', price: 18 },
    { name: 'Bacon & Cheese', price: 20 },
    { name: 'Dagwood', price: 25 },
    { name: 'Hotdogs', price: 12 },
  ]},
  { category: 'Kotas', items: [
    { name: 'Vienna Kota', price: 15 },
    { name: 'Russian Kota', price: 18 },
    { name: 'Egg Kota', price: 12 },
    { name: 'Patty Kota', price: 20 },
  ]},
  { category: 'Loose Meats', items: [
    { name: 'Vienna', price: 8 },
    { name: 'Russian', price: 10 },
  ]},
]

const YAWEHS_SWEET_TREATS = [
  { category: 'Sweet Treats', items: [
    { name: 'Muffins', price: 15 },
    { name: 'Doughnuts', price: 10 },
    { name: 'Cupcakes', price: 12 },
    { name: 'Cookies (pack)', price: 18 },
  ]},
]

const BRANCH_TABS = [
  { key: 'desres', label: 'Desres Kitchen', icon: Utensils },
  { key: 'yawehs', label: "Yahweh's Delight", icon: Cake },
]

const SUB_TABS = {
  desres: [
    { key: 'traditional', label: 'Traditional African Meals', icon: Flame, desc: 'Mukokoroshi, Steak, Mala & more' },
    { key: 'bakes', label: 'Daily Bakes', icon: Croissant, desc: 'Bread, scones, buns & sandwiches' },
  ],
  yawehs: [
    { key: 'breakfast', label: 'Breakfast, Kotas & Daily Bakes', icon: Coffee, desc: 'Toast, kotas, rolls & baked goods' },
    { key: 'sweets', label: 'Sweet Treats', icon: Cookie, desc: 'Muffins, doughnuts & cupcakes' },
    { key: 'custom', label: 'Customised Design', icon: Paintbrush, desc: 'Custom cakes & special orders', external: 'https://www.yahwehsdelight.co.za/' },
  ],
}

const MENU_MAP = {
  traditional: { menu: KITCHEN_FOOD_MENU, branchKey: 'kitchen' },
  bakes: { menu: KITCHEN_BAKERY_MENU, branchKey: 'bakery' },
  breakfast: { menu: YAWEHS_BREAKFAST_MENU, branchKey: 'yawehs' },
  sweets: { menu: YAWEHS_SWEET_TREATS, branchKey: 'yawehs' },
}

function Stars({ rating }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map(i => (
        <Star key={i} size={10} className={i <= Math.round(rating) ? 'text-ochre fill-ochre' : 'text-border-darker'} />
      ))}
    </div>
  )
}

function ScrollReveal({ children, delay = 0, className = '' }) {
  const [ref, inView] = useInView()
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: `opacity 0.7s ease-out ${delay}s, transform 0.7s ease-out ${delay}s`,
      }}
    >
      {children}
    </div>
  )
}

function MenuGrid({ menu, branchKey, stats }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {menu.map((group, gi) => (
        <ScrollReveal key={group.category} delay={0.1 + gi * 0.08}>
          <div className="relative bg-surface border border-border-dark rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.07)] hover:border-terracotta/40 transition-colors overflow-hidden">
            <div className="p-6">
              <h3 className="font-body text-[11px] font-semibold tracking-[0.25em] uppercase text-terracotta mb-4">
                {group.category}
              </h3>
              <div className="space-y-3">
                {group.items.map((item) => {
                  const key = productKey(branchKey, item.name)
                  const s = stats[key]
                  return (
                    <div key={item.name}>
                      <div className="flex items-center justify-between">
                        <div className="flex-1 min-w-0">
                          <span className="text-sm text-cream">{item.name}</span>
                          {s && (
                            <div className="flex items-center gap-2 mt-0.5">
                              {s.rating > 0 && (
                                <div className="flex items-center gap-1">
                                  <Stars rating={s.rating} />
                                  <span className="text-[10px] text-muted">
                                    {s.rating.toFixed(1)} ({s.reviewCount})
                                  </span>
                                </div>
                              )}
                              {s.totalSold > 0 && (
                                <span className="flex items-center gap-0.5 text-[10px] text-terracotta">
                                  <TrendingUp size={8} /> {s.totalSold}+ sold
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                        <span className="font-display text-lg text-terracotta">R{item.price}</span>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </ScrollReveal>
      ))}
    </div>
  )
}

export default function MenuPage() {
  const [searchParams] = useSearchParams()
  const [stats, setStats] = useState({})

  const initialBranch = searchParams.get('branch') === 'yawehs' ? 'yawehs' : 'desres'
  const [activeBranch, setActiveBranch] = useState(initialBranch)
  const [activeSubTab, setActiveSubTab] = useState(SUB_TABS[initialBranch][0].key)

  const handleBranchChange = (branchKey) => {
    setActiveBranch(branchKey)
    setActiveSubTab(SUB_TABS[branchKey][0].key)
  }

  useEffect(() => {
    getPublicStats().then(setStats)
  }, [])

  const currentSubTabs = SUB_TABS[activeBranch]
  const currentMenu = MENU_MAP[activeSubTab]

  return (
    <div>
      {/* Page header */}
      <section className="bg-charcoal relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-28">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-6 h-0.5 bg-terracotta" />
            <span className="font-body text-[11px] font-semibold tracking-[0.25em] uppercase text-terracotta">What We Serve</span>
          </div>
          <h1 className="font-display text-cream tracking-[0.04em] leading-[0.95]" style={{ fontSize: 'clamp(48px, 6vw, 88px)' }}>
            Our Menu
          </h1>
          <p className="text-sm text-muted mt-4 max-w-xl">
            From hearty traditional South African dishes to freshly baked goods — something for everyone.
          </p>
        </div>
      </section>

      {/* Branch tabs — sticky */}
      <div className="sticky top-16 z-40 bg-[rgba(240,235,225,0.97)] backdrop-blur-xl border-b border-border-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="flex">
            {BRANCH_TABS.map(tab => {
              const Icon = tab.icon
              return (
                <button
                  key={tab.key}
                  onClick={() => handleBranchChange(tab.key)}
                  className={`flex items-center gap-2 px-6 py-4 font-body text-[13px] font-semibold tracking-[0.08em] uppercase rounded-full transition-colors ${
                    activeBranch === tab.key
                      ? 'bg-terracotta text-white rounded-full'
                      : 'text-muted hover:text-cream'
                  }`}
                >
                  <Icon size={16} />
                  {tab.label}
                </button>
              )
            })}
          </div>
        </div>
      </div>

      {/* Sub-tabs */}
      <section className="bg-umber">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-10 pb-4">
          <div className={`grid gap-4 ${currentSubTabs.length === 2 ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-3'}`}>
            {currentSubTabs.map(tab => {
              const TabIcon = tab.icon
              const isActive = activeSubTab === tab.key && !tab.external

              if (tab.external) {
                return (
                  <a
                    key={tab.key}
                    href={tab.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex flex-col items-center gap-2 p-6 bg-surface border border-border-dark rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.07)] hover:border-terracotta/40 transition-colors text-center overflow-hidden"
                  >
                    <div className="w-14 h-14 bg-surface-high rounded-xl flex items-center justify-center">
                      <TabIcon size={24} className="text-ink-mid group-hover:text-terracotta transition-colors" />
                    </div>
                    <div>
                      <div className="flex items-center justify-center gap-1.5 font-body text-[13px] font-bold tracking-[0.05em] text-cream group-hover:text-terracotta transition-colors">
                        {tab.label} <ExternalLink size={12} />
                      </div>
                      <p className="text-xs text-muted mt-0.5">{tab.desc}</p>
                    </div>
                  </a>
                )
              }

              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveSubTab(tab.key)}
                  className={`relative flex flex-col items-center gap-2 p-6 border rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.07)] transition-colors text-center overflow-hidden ${
                    isActive
                      ? 'border-terracotta bg-ember-bg'
                      : 'border-border-dark bg-surface hover:border-terracotta/40'
                  }`}
                >
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${isActive ? 'bg-terracotta' : 'bg-surface-high'}`}>
                    <TabIcon size={24} className={isActive ? 'text-white' : 'text-ink-mid'} />
                  </div>
                  <div>
                    <p className={`font-body text-[13px] font-bold tracking-[0.05em] ${isActive ? 'text-terracotta' : 'text-cream'}`}>
                      {tab.label}
                    </p>
                    <p className="text-xs text-muted mt-0.5">{tab.desc}</p>
                  </div>
                </button>
              )
            })}
          </div>
        </div>
      </section>

      {/* Menu content */}
      {currentMenu && (
        <section className="bg-umber">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
            <MenuGrid
              menu={currentMenu.menu}
              branchKey={currentMenu.branchKey}
              stats={stats}
            />
          </div>
        </section>
      )}

      <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />

      {/* Bottom CTA */}
      <section className="bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-28">
          <ScrollReveal>
            <div className="relative bg-surface border border-border-dark rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.07)] overflow-hidden max-w-3xl mx-auto text-center">
              <div className="p-10">
                <p className="text-sm text-muted mb-6">
                  Prices are in South African Rands (ZAR). Menu items and prices are subject to change.
                </p>
                <Link
                  to="/"
                  className="inline-flex items-center justify-center gap-2 bg-terracotta text-white font-body text-[13px] font-bold tracking-[0.1em] uppercase px-9 py-4 rounded-full hover:bg-terracotta-glow hover:-translate-y-0.5 transition-all"
                >
                  <ShoppingCart size={16} /> Place an Order
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  )
}
